'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RegistrationForm = undefined;

var _RegistrationForm2 = require('./RegistrationForm');

var _RegistrationForm3 = _interopRequireDefault(_RegistrationForm2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RegistrationForm = _RegistrationForm3.default;


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/RegistrationForm/index.js
// module id = 1751
// module chunks = 0